import { createContext } from 'react';

export interface LandscapeContextType {
  mode: 'normal' | 'rotate' | 'rotate-instant' | 'suppressed';
  suppress: () => void;
  unsuppress: () => void;
  showRotatePrompt: (instant?: boolean) => void;
}

export const LandscapeContext = createContext<LandscapeContextType | null>(null);
